import { createFileRoute } from '@tanstack/react-router'
import { ManualScreen } from '@web/app/features/manual/screen'

// Definimos la estructura de nuestros parámetros de búsqueda
type Manual = {
  id?: string // Lo ponemos opcional por si entran a la URL vacía
}

export const Route = createFileRoute('/manual')({
  // Validamos los parámetros de búsqueda
  validateSearch: (search: Record<string, unknown>): Manual => {
    return {
      id: (search.id as string) || undefined,
    }
  },
  component: ManualScreen,
})
